import { getCurrentUser } from 'nuxt-vuefire/runtime/auth/composables.js'
import { usePendingPromises } from 'vuefire'

export default defineNuxtRouteMiddleware(async (to, from) => {
  const authUser = await getCurrentUser()

  const { canAccess } = useDataSchemas()

  if (authUser) {
    const { currentUser } = useUsers()
    await usePendingPromises() // wait for the current user to be populated

    console.log(currentUser.value)

    if (currentUser.value) {
      const lockedOut = !canAccess(new Date(), currentUser.value)
      if (lockedOut) {
        return navigateTo({
          path: '/models', //TODO: redirect a user to a page that tells them they need to pay
          query: {
            redirect: to.fullPath,
          },
        })
      }
    }
  }
})
